// extracted by mini-css-extract-plugin
export default {"how":"HowItWorks_how__QrVnC","hdr":"HowItWorks_hdr__DCvaK","sectionsWrpr":"HowItWorks_sectionsWrpr__acYYX","sec":"HowItWorks_sec__ANUAh","ftr":"HowItWorks_ftr__WiYrb"};